import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-white border-t border-gray-200 mt-auto">
      <div className="max-w-7xl mx-auto py-6 px-4 sm:px-6 md:flex md:items-center md:justify-between lg:px-8">
        <div className="flex justify-center space-x-6 md:order-2">
          <Link to="/privacy" className="text-gray-500 hover:text-gray-600">
            Privacy Policy
          </Link>
          <a href="mailto:support@postnudge.com" className="text-gray-500 hover:text-gray-600">
            Contact
          </a>
        </div>
        <div className="mt-4 md:mt-0 md:order-1">
          <p className="text-center text-sm text-gray-500">
            &copy; {new Date().getFullYear()} PostNudge. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
